import {
  TURN_ON_AGE_GROUPS,
  TURN_ON_BODY_TYPES,
  TURN_ON_ETHNICITIES,
  TURN_ON_GENDERS,
  type TurnOnAgeGroup,
  type TurnOnBodyType,
  type TurnOnEthnicity,
  type TurnOnGender,
} from '@fetmode/types';

export type TurnOnsSelection = {
  genders: TurnOnGender[];
  ageGroups: TurnOnAgeGroup[];
  ethnicities: TurnOnEthnicity[];
  bodyTypes: TurnOnBodyType[];
};

export const EMPTY_TURN_ONS_SELECTION: TurnOnsSelection = {
  genders: [],
  ageGroups: [],
  ethnicities: [],
  bodyTypes: [],
};

export const TURN_ONS_CATEGORIES = [
  {
    key: 'genders',
    titleKey: 'common.turnOns.categoryGender',
    options: TURN_ON_GENDERS,
    optionKeyPrefix: 'common.turnOns.gender',
  },
  {
    key: 'ageGroups',
    titleKey: 'common.turnOns.categoryAge',
    options: TURN_ON_AGE_GROUPS,
    optionKeyPrefix: 'common.turnOns.age',
  },
  {
    key: 'ethnicities',
    titleKey: 'common.turnOns.categoryEthnicity',
    options: TURN_ON_ETHNICITIES,
    optionKeyPrefix: 'common.turnOns.ethnicity',
  },
  {
    key: 'bodyTypes',
    titleKey: 'common.turnOns.categoryBody',
    options: TURN_ON_BODY_TYPES,
    optionKeyPrefix: 'common.turnOns.body',
  },
] as const;

export type TurnOnsCategoryKey = (typeof TURN_ONS_CATEGORIES)[number]['key'];
